import React from 'react';

export default function DownloadIcon({ color, size = 24 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2V14M12 14L15 11M12 14L9 11"
        stroke={color}
        strokeWidth="1.5"
      />
      <path d="M5 13V20H19V13" stroke={color} strokeWidth="1.5" />
    </svg>
  );
}
